export const LeftMenuBarEnum = {
    Dashboard: "Dashboard",
    Payroll: "Payroll",
    Employees: "Employees",
    Profile: "Profile"
};